export const TASK_TABLE_HEADER = [
  'Codigo de tarea',
  'Descripción',
  'Tiempo de tarea',
  'Cantidad',
  'Técnico Asignado',
];

export const TASK_TABLE_COLUMNS = [
  'serviceCode3',
  'description',
  'localFlat',
  'quantity',
  'name',
];

export const PARTS_TABLE_HEADER = [
  'Código de la parte',
  'Descripción',
  'Cantidad',
  'Precio Unitario',
  'Precio Total',
];

export const PARTS_TABLE_COLUMNS = [
  'partCode',
  'description',
  'quantity',
  'price',
  'total',
];

export const COMMENTS_TABLE_HEADER = [
  'Tipo',
  'Orden ',
  'Observación',
  'Fecha',
];


export const COMMENTS_TABLE_COLUMNS = [
  'type',
  'orderId',
  'incomeComments',
  'date',
];

export const SUBTASK_TABLE_HEADER = [
  'Código de Tarea',
  'Descripción',
  'Tiempo de Tarea',
  'Cliente',
  'Cantidad',
  'Precio ',
  'Días de trabajo ',
  'Fecha de solicitud',
  'Fecha de entrega',
  'Observación',
];

export const SUBTASK_TABLE_COLUMNS = [
  'code',
  'description',
  'localFlat',
  'client',
  'quantity',
  'price',
  'daysWork',
  'requestDate',
  'deliveryDate',
  'observation',
];
